module.exports = "//cdn.mxpnl.com/static/asset-cache/ab69a061e658d9fc95685af6cfa1d019/iron/common/widgets/intro/event-carousel/images/donut-event.png";